import {
  BaseRepository,
  IEnumerableResponse,
  ITableRequestParams
} from '@app/src/common/repository/BaseRepository';
import {
  IAddDictionaryItems,
  ICreateDictionaryItem,
  IDictionary,
  IDictionaryItem
} from '@app/src/components/event-management/model/Dictionary';

interface IDictionaryParams {
  includeDeleted?: boolean;
  languageCode?: string;
}

class DictionaryRepository extends BaseRepository {
  dictionaryUrl = `${this.ereceptionstUrl}/Dictionaries`;

  public getDictionaries(
    params?: ITableRequestParams
  ): Promise<IEnumerableResponse<IDictionary>> {
    return this.callGet<IEnumerableResponse<IDictionary>>(
      this.dictionaryUrl,
      params
    ).then(response => response.data);
  }

  public getDictionaryById(id: string): Promise<IDictionary> {
    return this.callGet<IDictionary>(`${this.dictionaryUrl}/${id}`).then(
      response => response.data
    );
  }

  public createDictionary(body: Partial<IDictionary>): Promise<string> {
    return this.callPost<string>(this.dictionaryUrl, body).then(
      response => response.data
    );
  }

  public updateDictionary(
    id: string,
    body: Partial<IDictionary>
  ): Promise<IDictionary> {
    return this.callPut<IDictionary>(`${this.dictionaryUrl}/${id}`, body).then(
      response => response.data
    );
  }

  public deleteDictionary(id: string): Promise<void> {
    return this.callDelete(`${this.dictionaryUrl}/${id}`).then(() => undefined);
  }

  public getDictionaryItemsByKey(
    key: string,
    params?: IDictionaryParams
  ): Promise<IDictionaryItem[]> {
    return this.callGet<IDictionaryItem[]>(
      `${this.dictionaryUrl}/key/${encodeURIComponent(key)}/items`,
      params
    ).then(response => response.data);
  }

  public getDictionaryItemByKey(
    dictionaryKey: string,
    itemKey: string
  ): Promise<IDictionaryItem> {
    return this.callGet<IDictionaryItem>(
      `${this.dictionaryUrl}/key/${encodeURIComponent(dictionaryKey)}/items/${encodeURIComponent(itemKey)}`
    ).then(response => response.data);
  }

  public createDictionaryItem(dictionaryId: string, body: IAddDictionaryItems) {
    return this.callPost<IDictionaryItem>(
      `${this.dictionaryUrl}/${dictionaryId}/items`,
      body
    );
  }

  public updateDictionaryItem(
    dictionaryId: string,
    itemId: string,
    body: Partial<ICreateDictionaryItem>
  ) {
    return this.callPut(
      `${this.dictionaryUrl}/${dictionaryId}/items/${itemId}`,
      body
    );
  }

  public deleteDictionaryItems(dictionaryId: string, ids: string[]) {
    return this.callDelete(`${this.dictionaryUrl}/${dictionaryId}/items`, {
      ids
    });
  }
}

export default new DictionaryRepository();
